import { GraphQLBoolean, GraphQLNonNull, GraphQLObjectType } from 'graphql';
import { TypeNames } from '../../types';
const LinkedAccounts = new GraphQLObjectType({
  fields: {
    google: {
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    microsoft: {
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    apple: {
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    saml: {
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  },
  name: TypeNames.USER_MANAGE_LINKED_ACCOUNTS
});
export default LinkedAccounts;